import { useEffect, useRef, useState } from 'react';

import type { ChatMessage } from '@karehero/models';

/**
 * useChatSystemSender lands Keni's lines after a beat with the dots showing,
 * then does what follows them. Zero delay lands them at once.
 */
export const useChatSystemSender = (
  persist: (message: ChatMessage) => void,
  thinkDelayMs: number,
) => {
  const [isThinking, setIsThinking] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);
  useEffect(() => () => clearTimeout(timer.current), []);

  const speak = (lines: ChatMessage[], then?: () => void) => {
    const land = () => {
      lines.forEach((line) => persist(line));
      setIsThinking(false);
      then?.();
    };
    if (thinkDelayMs <= 0) {
      land();
      return;
    }
    setIsThinking(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(land, thinkDelayMs);
  };

  return { isThinking, speak };
};
